import '../../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.constructor.mjs';
import '../../../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.reduce.mjs';
import { BI_BACKGROUND_INFO } from './background.mjs';

const BankScheme = {
  BK_K_NPAY: {
    symbolSize: [42, 42],
    textSize: null,
    plateTextSize: [106, 14]
  },
  BK_SHINHAN_NPAY: {
    symbolSize: [42, 42],
    textSize: null,
    plateTextSize: [125, 16]
  },
  BK_BNP: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_BOA: {
    textSize: null,
    symbolSize: [30, 24]
  },
  BK_BUSAN: {
    textSize: [88, 20],
    symbolSize: [36, 24],
    plateTextSize: [86, 20]
  },
  BK_CCB: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_CHINA: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_CITI: {
    textSize: [58, 20],
    symbolSize: [27, 24],
    plateTextSize: [58, 20]
  },
  BK_CU: {
    textSize: [50, 20],
    symbolSize: [25, 24],
    plateTextSize: [50, 20]
  },
  BK_DAEGU: {
    textSize: [65, 20],
    symbolSize: [29, 24],
    plateTextSize: [65, 20]
  },
  BK_DEUTSCH: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_EPOST: {
    textSize: [64, 20],
    symbolSize: [30, 24],
    plateTextSize: [64, 20]
  },
  BK_EXIM: {
    textSize: [80, 20],
    symbolSize: [24, 24],
    plateTextSize: [80, 20]
  },
  BK_HANA: {
    textSize: [70, 20],
    symbolSize: [28, 24],
    plateTextSize: [70, 20]
  },
  BK_HF: {
    textSize: [100, 20],
    symbolSize: [24, 24],
    plateTextSize: [100, 20]
  },
  BK_HSBC: {
    textSize: [68, 20],
    symbolSize: [32, 24],
    plateTextSize: [68, 20]
  },
  BK_IBK: {
    textSize: [85, 20],
    symbolSize: [24, 24],
    plateTextSize: [85, 20]
  },
  BK_ICBC: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_JEJU: {
    textSize: [70, 20],
    symbolSize: [24, 24],
    plateTextSize: [70, 20]
  },
  BK_JEONBUK: {
    textSize: [70, 20],
    symbolSize: [24, 24],
    plateTextSize: [70, 20]
  },
  BK_JPMORGAN: {
    textSize: null,
    symbolSize: [24, 24]
  },
  BK_KAKAO: {
    textSize: [82, 20],
    symbolSize: [24, 24],
    plateTextSize: [72, 20]
  },
  BK_KB: {
    textSize: [95, 20],
    symbolSize: [28, 24],
    plateTextSize: [95, 20]
  },
  BK_KDB: {
    textSize: [100, 20],
    symbolSize: [25, 24],
    plateTextSize: [100, 20]
  },
  BK_KFCC: {
    textSize: [100, 20],
    symbolSize: [26, 24],
    plateTextSize: [100, 20]
  },
  BK_KINFA: {
    textSize: [75, 20],
    symbolSize: [24, 24],
    plateTextSize: [75, 20]
  },
  BK_KOSAF: {
    textSize: [85, 20],
    symbolSize: [30, 24],
    plateTextSize: [85, 20]
  },
  BK_KWANGJU: {
    textSize: [70, 20],
    symbolSize: [24, 24],
    plateTextSize: [70, 20]
  },
  BK_KYOUNGNAM: {
    textSize: [88, 20],
    symbolSize: [36, 24],
    plateTextSize: [86, 20]
  },
  BK_K: {
    textSize: [52, 20],
    symbolSize: [45, 24],
    plateTextSize: [52, 20]
  },
  BK_NFCF: {
    textSize: [85, 20],
    symbolSize: [30, 24],
    plateTextSize: [85, 20]
  },
  BK_NHCENTRAL: {
    textSize: [86, 20],
    symbolSize: [20, 24],
    plateTextSize: [86, 20]
  },
  BK_NH: {
    textSize: [92, 20],
    symbolSize: [28, 24],
    plateTextSize: [91, 20]
  },
  BK_SC: {
    textSize: [82, 20],
    symbolSize: [17, 24],
    plateTextSize: [56, 20]
  },
  BK_SHCENTRAL: {
    textSize: [80, 20],
    symbolSize: [30, 24],
    plateTextSize: [78, 20]
  },
  BK_SHINHAN: {
    textSize: [70, 20],
    symbolSize: [24, 24],
    plateTextSize: [70, 20]
  },
  BK_SH: {
    textSize: [70, 20],
    symbolSize: [26, 24],
    plateTextSize: [68, 20]
  },
  BK_TOSS: {
    textSize: [95, 20],
    symbolSize: [25, 24],
    plateTextSize: [95, 20]
  },
  BK_WOORI: {
    textSize: [70, 20],
    symbolSize: [24, 24],
    plateTextSize: [69, 20]
  }
};
const InvestScheme = {
  IV_BNK: {
    symbolSize: [36, 24],
    plateTextSize: [80, 20],
    textSize: [80, 20]
  },
  IV_BOOKOOK: {
    symbolSize: [34, 24],
    plateTextSize: [74, 20],
    textSize: [74, 20]
  },
  IV_CAPE: {
    symbolSize: [24, 24],
    plateTextSize: [87, 20],
    textSize: [87, 20]
  },
  IV_DAISHIN: {
    symbolSize: [22, 24],
    plateTextSize: [74, 20],
    textSize: [74, 20]
  },
  IV_DAOL: {
    symbolSize: [44, 24],
    plateTextSize: [83, 20],
    textSize: [83, 20]
  },
  IV_DBFI: {
    symbolSize: [20, 24],
    plateTextSize: [76, 20],
    textSize: [76, 20]
  },
  IV_DS: {
    symbolSize: [29, 24],
    plateTextSize: [54, 20],
    textSize: [54, 20]
  },
  IV_EUGENE: {
    symbolSize: [24, 24],
    plateTextSize: [85, 20],
    textSize: [85, 20]
  },
  IV_FOSS: {
    symbolSize: [24, 24],
    plateTextSize: [82, 20],
    textSize: [82, 20]
  },
  IV_HANA: {
    symbolSize: [25, 24],
    plateTextSize: [68, 20],
    textSize: [68, 20]
  },
  IV_HANKUK: {
    symbolSize: [24, 24],
    plateTextSize: [73, 20],
    textSize: [73, 20]
  },
  IV_HANWHA: {
    symbolSize: [25, 24],
    plateTextSize: [79, 20],
    textSize: [79, 20]
  },
  IV_HANYANG: {
    symbolSize: [23, 24],
    plateTextSize: [65, 20],
    textSize: [65, 20]
  },
  IV_HEUNGKUK: {
    symbolSize: [26, 24],
    plateTextSize: [75, 20],
    textSize: [75, 20]
  },
  IV_HI: {
    symbolSize: [29, 24],
    plateTextSize: [85, 20],
    textSize: [85, 20]
  },
  IV_HM: {
    symbolSize: [24, 24],
    plateTextSize: [59, 20],
    textSize: [59, 20]
  },
  IV_IBK: {
    symbolSize: [24, 24],
    plateTextSize: [75, 20],
    textSize: [75, 20]
  },
  IV_KAKAOPAY: {
    symbolSize: [42, 24],
    plateTextSize: [67, 20],
    textSize: [67, 20]
  },
  IV_KB: {
    symbolSize: [28, 24],
    plateTextSize: [70, 20],
    textSize: [70, 20]
  },
  IV_KIWOOM: {
    symbolSize: [18, 24],
    plateTextSize: [58, 20],
    textSize: [58, 20]
  },
  IV_KOREAASSET: {
    symbolSize: [28, 24],
    plateTextSize: [72, 20],
    textSize: [72, 20]
  },
  IV_KOREA: {
    symbolSize: [20, 24],
    plateTextSize: [71, 20],
    textSize: [71, 20]
  },
  IV_KR: {
    symbolSize: [28, 24],
    plateTextSize: [71, 20],
    textSize: [71, 20]
  },
  IV_KTB: {
    symbolSize: [44, 24],
    plateTextSize: [83, 20],
    textSize: [83, 20]
  },
  IV_KYOBO: {
    symbolSize: [43, 24],
    plateTextSize: [64, 20],
    textSize: [64, 20]
  },
  IV_LEADING: {
    symbolSize: [27, 24],
    plateTextSize: [60, 20],
    textSize: [60, 20]
  },
  IV_LS: {
    symbolSize: [30, 24],
    plateTextSize: [39, 20],
    textSize: [42, 20]
  },
  IV_MACQUARIE: {
    symbolSize: [24, 24],
    plateTextSize: [70, 20],
    textSize: [70, 20]
  },
  IV_MERITZ: {
    symbolSize: [44, 24],
    plateTextSize: [90, 20],
    textSize: [90, 20]
  },
  IV_MIRAE: {
    symbolSize: [58, 24],
    plateTextSize: [58, 20],
    textSize: [58, 20]
  },
  IV_NAVER_MIRAE: {
    symbolSize: null,
    plateTextSize: [70, 20]
  },
  IV_NH: {
    symbolSize: [20, 24],
    plateTextSize: [93, 20],
    textSize: [93, 20]
  },
  IV_SAMSUNG: {
    symbolSize: [45, 24],
    plateTextSize: [50, 20],
    textSize: [50, 20]
  },
  IV_SHINHAN: {
    symbolSize: [24, 24],
    plateTextSize: [93, 20],
    textSize: [93, 20]
  },
  IV_SHINYOUNG: {
    symbolSize: [21, 24],
    plateTextSize: [62, 20],
    textSize: [62, 20]
  },
  IV_SK: {
    symbolSize: [31, 24],
    plateTextSize: [35, 20],
    textSize: [35, 20]
  },
  IV_SSIN: {
    symbolSize: [26, 24],
    plateTextSize: [73, 20],
    textSize: [73, 20]
  },
  IV_TOSS: {
    symbolSize: [25, 24],
    plateTextSize: [72, 20],
    textSize: [72, 20]
  },
  IV_WOORI: {
    symbolSize: [24, 24],
    plateTextSize: [82, 20],
    textSize: [82, 20]
  },
  IV_YUANTA: {
    symbolSize: [24, 24],
    plateTextSize: [82, 20],
    textSize: [82, 20]
  },
  IV_YUHWA: {
    symbolSize: [24, 24],
    plateTextSize: [70, 20],
    textSize: [70, 20]
  }
};
const CardScheme = {
  CD_BC: {
    plateTextSize: [60, 20],
    textSize: [60, 20]
  },
  CD_BUSAN: {
    plateTextSize: [72, 20],
    textSize: [72, 20]
  },
  CD_CITI_BANK: {
    plateTextSize: [30, 20],
    textSize: [30, 20]
  },
  CD_CU: {
    plateTextSize: [46, 20],
    textSize: [46, 20]
  },
  CD_DAEGU: {
    plateTextSize: [65, 20],
    textSize: [65, 20]
  },
  CD_EPOST: {
    plateTextSize: [59, 20],
    textSize: [59, 20]
  },
  CD_GALLERIA_DS: {
    plateTextSize: [27, 20],
    textSize: [27, 20]
  },
  CD_HANA: {
    plateTextSize: [62, 20],
    textSize: [62, 20]
  },
  CD_HANKOOK_STOCK: {
    plateTextSize: [66, 20],
    textSize: [66, 20]
  },
  CD_HANWHA_STOCK: {
    plateTextSize: [74, 20],
    textSize: [74, 20]
  },
  CD_HYUNDAI_DS: {
    plateTextSize: [65, 20],
    textSize: [65, 20]
  },
  CD_HYUNDAI: {
    plateTextSize: [71, 20],
    textSize: [71, 20]
  },
  CD_IBK: {
    plateTextSize: [74, 20],
    textSize: [74, 20]
  },
  CD_JEJU_BANK: {
    plateTextSize: [60, 20],
    textSize: [60, 20]
  },
  CD_JEONBUK: {
    plateTextSize: [64, 20],
    textSize: [64, 20]
  },
  CD_KAKAO_BANK: {
    plateTextSize: [68, 20],
    textSize: [68, 20]
  },
  CD_KAKAO_PAY: {
    plateTextSize: [42, 20],
    textSize: [46, 20]
  },
  CD_KB_STOCK: {
    plateTextSize: [58, 20],
    textSize: [58, 20]
  },
  CD_KB: {
    plateTextSize: [80, 20],
    textSize: [80, 20]
  },
  CD_KDB: {
    plateTextSize: [81, 20],
    textSize: [81, 20]
  },
  CD_KFCC: {
    plateTextSize: [87, 20],
    textSize: [87, 20]
  },
  CD_KWANGJU: {
    plateTextSize: [64, 20],
    textSize: [64, 20]
  },
  CD_KYOUNGNAM: {
    plateTextSize: [72, 20],
    textSize: [72, 20]
  },
  CD_K_BANK: {
    plateTextSize: [48, 20],
    textSize: [48, 20]
  },
  CD_LOTTE: {
    plateTextSize: [48, 20],
    textSize: [48, 20]
  },
  CD_MASTER_CARD: {
    plateTextSize: [28, 20],
    textSize: [28, 20]
  },
  CD_MIRAE_STOCK: {
    plateTextSize: [59, 20],
    textSize: [59, 20]
  },
  CD_NAVER_PAY: {
    plateTextSize: [48, 20],
    textSize: [48, 20]
  },
  CD_NH_STOCK: {
    plateTextSize: [72, 20],
    textSize: [72, 20]
  },
  CD_NH: {
    plateTextSize: [77, 20],
    textSize: [77, 20]
  },
  CD_SAMSUNG: {
    plateTextSize: [46, 20],
    textSize: [46, 20]
  },
  CD_SC: {
    plateTextSize: [56, 20],
    textSize: [56, 20]
  },
  CD_SHINHAN: {
    plateTextSize: [60, 20],
    textSize: [60, 20]
  },
  CD_SH: {
    plateTextSize: [40, 20],
    textSize: [40, 20]
  },
  CD_SK_STOCK: {
    plateTextSize: [35, 20],
    textSize: [35, 20]
  },
  CD_TOSS_BANK: {
    plateTextSize: [74, 20],
    textSize: [74, 20]
  },
  CD_VISA: {
    plateTextSize: [50, 20],
    textSize: [50, 20]
  },
  CD_WOORI: {
    plateTextSize: [62, 20],
    textSize: [58, 20]
  },
  CD_YUANTA_STOCK: {
    plateTextSize: [72, 20],
    textSize: [72, 20]
  }
};
const SavingBankScheme = {
  SB_ACUON: {
    symbolSize: [24, 24]
  },
  SB_ANGUK: {
    symbolSize: [24, 24]
  },
  SB_ANYANG: {
    symbolSize: [24, 24]
  },
  SB_ASAN: {
    symbolSize: [24, 24]
  },
  SB_BARO: {
    symbolSize: [46, 24]
  },
  SB_BNK: {
    symbolSize: [36, 24]
  },
  SB_BOORIM: {
    symbolSize: [24, 24]
  },
  SB_CENTRAL: {
    symbolSize: [32, 24]
  },
  SB_CHOEUN: {
    symbolSize: [24, 22]
  },
  SB_CHOHEUNG: {
    symbolSize: [22, 22]
  },
  SB_CHUNGJU: {
    symbolSize: [27, 22]
  },
  SB_CK: {
    symbolSize: [24, 24]
  },
  SB_COMMON: {
    symbolSize: [24, 24],
    plateTextSize: [69, 18],
    textSize: [69, 18]
  },
  SB_COREA: {
    symbolSize: [24, 24]
  },
  SB_DAEAH: {
    symbolSize: [24, 24]
  },
  SB_DAEBAEK: {
    symbolSize: [24, 24]
  },
  SB_DAEHAN: {
    symbolSize: [26, 24]
  },
  SB_DAEMYUNG: {
    symbolSize: [37, 24]
  },
  SB_DAEWON: {
    symbolSize: [24, 24]
  },
  SB_DAISHIN: {
    symbolSize: [22, 22]
  },
  SB_DAOL: {
    symbolSize: [40, 24]
  },
  SB_DB: {
    symbolSize: [24, 24]
  },
  SB_DH: {
    symbolSize: [25, 24]
  },
  SB_DONGWONJEIL: {
    symbolSize: [24, 24]
  },
  SB_DONGYANG: {
    symbolSize: [24, 24]
  },
  SB_DOUBLE: {
    symbolSize: [24, 24]
  },
  SB_DREAM: {
    symbolSize: [25, 24]
  },
  SB_HANA: {
    symbolSize: [28, 24]
  },
  SB_HANSUNG: {
    symbolSize: [24, 24]
  },
  SB_HANWHA: {
    symbolSize: [26, 24]
  },
  SB_HB: {
    symbolSize: [24, 24]
  },
  SB_HEUNGKUK: {
    symbolSize: [50, 24]
  },
  SB_IBK: {
    symbolSize: [24, 24]
  },
  SB_INCHEON: {
    symbolSize: [31, 22]
  },
  SB_INSUNG: {
    symbolSize: [31, 24]
  },
  SB_JINJU: {
    symbolSize: [22, 24]
  },
  SB_JTCHINE: {
    symbolSize: [24, 24]
  },
  SB_JT: {
    symbolSize: [27, 24]
  },
  SB_KB: {
    symbolSize: [28, 24]
  },
  SB_KIWOOMYES: {
    symbolSize: [18, 24]
  },
  SB_KIWOOM: {
    symbolSize: [18, 24]
  },
  SB_KOOKJE: {
    symbolSize: [24, 24]
  },
  SB_KOREAINVEST: {
    symbolSize: [24, 24]
  },
  SB_KUMHWA: {
    symbolSize: [26, 24]
  },
  SB_LENDIT: {
    symbolSize: [45, 24]
  },
  SB_MK: {
    symbolSize: [28, 24]
  },
  SB_MOA: {
    symbolSize: [24, 24]
  },
  SB_MS: {
    symbolSize: [31, 24]
  },
  SB_MUSTSAMIL: {
    symbolSize: [24, 24]
  },
  SB_NAMYANG: {
    symbolSize: [24, 24]
  },
  SB_NH: {
    symbolSize: [20, 24]
  },
  SB_OHSUNG: {
    symbolSize: [28, 24]
  },
  SB_OHTOO: {
    symbolSize: [28, 24]
  },
  SB_OK: {
    symbolSize: [32, 24]
  },
  SB_OSB: {
    symbolSize: [22, 24]
  },
  SB_PEPPER: {
    symbolSize: [43, 24]
  },
  SB_PURUN: {
    symbolSize: [28, 24]
  },
  SB_PYUNGTAEK: {
    symbolSize: [24, 24]
  },
  SB_RAON: {
    symbolSize: [34, 24]
  },
  SB_SAMHO: {
    symbolSize: [28, 24]
  },
  SB_SAMJUNG: {
    symbolSize: [28, 24]
  },
  SB_SBI2: {
    symbolSize: [28, 24],
    plateTextSize: [70, 18],
    textSize: [70, 18]
  },
  SB_SBI: {
    symbolSize: [28, 24],
    plateTextSize: [70, 18],
    textSize: [70, 18]
  },
  SB_SERAM: {
    symbolSize: [26, 24]
  },
  SB_SHINHAN: {
    symbolSize: [24, 24]
  },
  SB_SKY: {
    symbolSize: [28, 24]
  },
  SB_SMART: {
    symbolSize: [37, 24]
  },
  SB_SNT: {
    symbolSize: [40, 24]
  },
  SB_SOLBRAIN: {
    symbolSize: [46, 24]
  },
  SB_SSINPLUS: {
    symbolSize: [28, 24]
  },
  SB_SSIN: {
    symbolSize: [28, 24]
  },
  SB_STAR: {
    symbolSize: [33, 24]
  },
  SB_THEK: {
    symbolSize: [41, 24]
  },
  SB_TRUE: {
    symbolSize: [22, 22]
  },
  SB_UNION: {
    symbolSize: [35, 24]
  },
  SB_WELCOME: {
    symbolSize: [26, 24]
  },
  SB_WOORIFIN: {
    symbolSize: [24, 24]
  },
  SB_WOORI: {
    symbolSize: [31, 24]
  },
  SB_YEKARAM: {
    symbolSize: [26, 24]
  },
  SB_YOONGCHANG: {
    symbolSize: [38, 24]
  },
  SB_YOUNGJIN: {
    symbolSize: [24, 24]
  },
  SB_YUANTA: {
    symbolSize: [24, 24]
  }
};
const InsuranceScheme = {
  IS_ABL: {
    symbolSize: [36, 24]
  },
  IS_AIGFIRE: {
    symbolSize: [34, 24]
  },
  IS_AIGLIFE: {
    symbolSize: [26, 25]
  },
  IS_AXA: {
    symbolSize: [24, 24]
  },
  IS_BNPFIRE: {
    symbolSize: [24, 24]
  },
  IS_BNPLIFE: {
    symbolSize: [24, 24]
  },
  IS_CARROT: {
    symbolSize: [24, 24]
  },
  IS_CHUBBLIFE: {
    symbolSize: [42, 24]
  },
  IS_DBFIRE: {
    symbolSize: [24, 24]
  },
  IS_DBLIFE: {
    symbolSize: [24, 24]
  },
  IS_DGB: {
    symbolSize: [29, 24]
  },
  IS_DONGYANG: {
    symbolSize: [40, 24]
  },
  IS_FUBON: {
    symbolSize: [24, 24]
  },
  IS_HANAFIRE: {
    symbolSize: [28, 24]
  },
  IS_HANALIFE: {
    symbolSize: [28, 24]
  },
  IS_HANWHAFIRE: {
    symbolSize: [24, 24]
  },
  IS_HANWHALIFE: {
    symbolSize: [24, 24]
  },
  IS_HEUNGKUKFIRE: {
    symbolSize: [26, 24]
  },
  IS_HEUNGKUKLIFE: {
    symbolSize: [26, 24]
  },
  IS_HI: {
    symbolSize: [24, 24]
  },
  IS_IBKI: {
    symbolSize: [25, 24]
  },
  IS_KAKAO_PAY_FIRE: {
    symbolSize: [42, 20]
  },
  IS_KBFIRE: {
    symbolSize: [28, 24]
  },
  IS_KB_PRUDENTIAL: {
    symbolSize: [28, 24]
  },
  IS_KDB: {
    symbolSize: [26, 24]
  },
  IS_KOREAPOST: {
    symbolSize: [30, 24]
  },
  IS_KYOBOLIFE: {
    symbolSize: [37, 24]
  },
  IS_LIFEPLANET: {
    symbolSize: [24, 24]
  },
  IS_LINAFIRE: {
    symbolSize: [26, 24]
  },
  IS_LINALIFE: {
    symbolSize: [26, 24]
  },
  IS_LOTTE: {
    symbolSize: [34, 24]
  },
  IS_MERITZFIRE: {
    symbolSize: [44, 24]
  },
  IS_MET: {
    symbolSize: [26, 24]
  },
  IS_MG: {
    symbolSize: [26, 24]
  },
  IS_MIRAE: {
    symbolSize: [57, 24]
  },
  IS_NHFIRE: {
    symbolSize: [20, 24]
  },
  IS_NHLIFE: {
    symbolSize: [20, 24]
  },
  IS_SAMSUNGFIRE: {
    symbolSize: [42, 24]
  },
  IS_SAMSUNGLIFE: {
    symbolSize: [42, 24]
  },
  IS_SGIC: {
    symbolSize: [24, 24]
  },
  IS_SHINHAN: {
    symbolSize: [24, 24]
  },
  IS_THEK: {
    symbolSize: [36, 24]
  }
};
const CapitalScheme = {
  CAPITAL_8PERCENT: {
    symbolSize: [24, 24]
  },
  CAPITAL_ACUON: {
    symbolSize: [24, 24]
  },
  CAPITAL_A: {
    symbolSize: [44, 24]
  },
  CAPITAL_BC_CARD: {
    symbolSize: [60, 24]
  },
  CAPITAL_BMW: {
    symbolSize: [24, 24]
  },
  CAPITAL_BNK: {
    symbolSize: [36, 24]
  },
  CAPITAL_CNH: {
    symbolSize: [28, 24]
  },
  CAPITAL_DB: {
    symbolSize: [24, 24]
  },
  CAPITAL_DEUTSCH: {
    symbolSize: [24, 24]
  },
  CAPITAL_DGB: {
    symbolSize: [29, 24]
  },
  CAPITAL_ECO: {
    symbolSize: [24, 24]
  },
  CAPITAL_HANA_CARD: {
    symbolSize: [54, 24]
  },
  CAPITAL_HANA: {
    symbolSize: [28, 24]
  },
  CAPITAL_HANKOOK: {
    symbolSize: [28, 24]
  },
  CAPITAL_HB: {
    symbolSize: [24, 24]
  },
  CAPITAL_HONESTFUND: {
    symbolSize: [24, 24]
  },
  CAPITAL_HYUNDAI_COMMERCIAL: {
    symbolSize: [60, 24]
  },
  CAPITAL_HYUNDAI: {
    symbolSize: [60, 24]
  },
  CAPITAL_IBK: {
    symbolSize: [25, 24]
  },
  CAPITAL_JB_WOORI: {
    symbolSize: [24, 24]
  },
  CAPITAL_KB_CARD: {
    symbolSize: [68, 24]
  },
  CAPITAL_KB: {
    symbolSize: [32, 24]
  },
  CAPITAL_KDBC: {
    symbolSize: [25, 24]
  },
  CAPITAL_KICF: {
    symbolSize: [24, 24]
  },
  CAPITAL_KIWWOOM: {
    symbolSize: [20, 24]
  },
  CAPITAL_KN: {
    symbolSize: [60, 24]
  },
  CAPITAL_K_CAR: {
    symbolSize: [38, 24]
  },
  CAPITAL_LOTTE_AUTOLEASE: {
    symbolSize: [24, 24]
  },
  CAPITAL_LOTTE_CARD: {
    symbolSize: [60, 24]
  },
  CAPITAL_LOTTE: {
    symbolSize: [25, 24]
  },
  CAPITAL_MASON: {
    symbolSize: [60, 24]
  },
  CAPITAL_MERCEDES_BENZ: {
    symbolSize: [24, 24]
  },
  CAPITAL_MERITZ: {
    symbolSize: [44, 24]
  },
  CAPITAL_MIRAE: {
    symbolSize: [60, 24]
  },
  CAPITAL_MOORIM: {
    symbolSize: [36, 24]
  },
  CAPITAL_M: {
    symbolSize: [24, 24]
  },
  CAPITAL_NH: {
    symbolSize: [20, 24]
  },
  CAPITAL_OK: {
    symbolSize: [32, 24]
  },
  CAPITAL_ORIX: {
    symbolSize: [26, 24]
  },
  CAPITAL_PEOPLE_FUND: {
    symbolSize: [29, 24]
  },
  CAPITAL_PORSCHE: {
    symbolSize: [24, 24]
  },
  CAPITAL_RCI: {
    symbolSize: [60, 24]
  },
  CAPITAL_SAMSUNG_CARD: {
    symbolSize: [50, 24]
  },
  CAPITAL_SHINHAN_CARD: {
    symbolSize: [56, 24]
  },
  CAPITAL_SHINHAN: {
    symbolSize: [24, 24]
  },
  CAPITAL_SY: {
    symbolSize: [26, 24]
  },
  CAPITAL_TOYOTA: {
    symbolSize: [28, 24]
  },
  CAPITAL_VOLKSWAGEN: {
    symbolSize: [24, 24]
  },
  CAPITAL_VOLVO: {
    symbolSize: [24, 24]
  },
  CAPITAL_WELCOME: {
    symbolSize: [26, 24]
  },
  CAPITAL_WOORIF: {
    symbolSize: [24, 24]
  },
  CAPITAL_WOORI_CARD: {
    symbolSize: [60, 24]
  }
};
const TelecomScheme = {
  TEL_ACN: {
    symbolSize: [38, 24]
  },
  TEL_A: {
    symbolSize: [23, 24]
  },
  TEL_CMB: {
    symbolSize: [39, 24]
  },
  TEL_COINSHOT: {
    symbolSize: [53, 24]
  },
  TEL_DLIVE: {
    symbolSize: [48, 24]
  },
  TEL_EG: {
    symbolSize: [27, 24]
  },
  TEL_EYAGI: {
    symbolSize: [42, 24]
  },
  TEL_EYES: {
    symbolSize: [22, 24]
  },
  TEL_FINDIRECT: {
    symbolSize: [24, 24]
  },
  TEL_FREET: {
    symbolSize: [44, 24]
  },
  TEL_HCN: {
    symbolSize: [32, 24]
  },
  TEL_HELLOVISION: {
    symbolSize: [42, 24]
  },
  TEL_INSCOBEE: {
    symbolSize: [44, 24]
  },
  TEL_JCN: {
    symbolSize: [38, 24]
  },
  TEL_KCT: {
    symbolSize: [38, 24]
  },
  TEL_KONAI: {
    symbolSize: [44, 24]
  },
  TEL_KPMO: {
    symbolSize: [39, 24]
  },
  TEL_KTM: {
    symbolSize: [61, 24]
  },
  TEL_KT: {
    symbolSize: [24, 24]
  },
  TEL_LGU: {
    symbolSize: [25, 24]
  },
  TEL_LIIVM: {
    symbolSize: [37, 24]
  },
  TEL_MOBING: {
    symbolSize: [47, 24]
  },
  TEL_NIB: {
    symbolSize: [41, 24]
  },
  TEL_ONKUKMIN: {
    symbolSize: [27, 24]
  },
  TEL_S1: {
    symbolSize: [53, 24]
  },
  TEL_SEJONG: {
    symbolSize: [57, 24]
  },
  TEL_SK7: {
    symbolSize: [67, 24]
  },
  TEL_SKB: {
    symbolSize: [19, 24]
  },
  TEL_SKT: {
    symbolSize: [22, 24]
  },
  TEL_SKYLIFE: {
    symbolSize: [51, 24]
  },
  TEL_SMARTEL: {
    symbolSize: [62, 24]
  },
  TEL_TOSS: {
    symbolSize: [25, 24]
  },
  TEL_U: {
    symbolSize: [63, 24]
  },
  TEL_WINNERSTEL: {
    symbolSize: [37, 24]
  },
  TEL_YLLAND: {
    symbolSize: [38, 24]
  }
};
const PointScheme = {
  POINT_11STREET: {
    symbolSize: [36, 24]
  },
  POINT_BAEMIN: {
    symbolSize: [53, 24]
  },
  POINT_BANKSALAD: {
    symbolSize: [24, 24]
  },
  POINT_BLUEWALNUT: {
    symbolSize: [54, 24]
  },
  POINT_BUSANHANAROCARD: {
    symbolSize: [61, 24]
  },
  POINT_CARROTPAY: {
    symbolSize: [41, 24]
  },
  POINT_COOCON: {
    symbolSize: [49, 24]
  },
  POINT_COUPANGPAY: {
    symbolSize: [50, 24]
  },
  POINT_DECNCOMASSETMANAGEMENT: {
    symbolSize: [31, 24]
  },
  POINT_DGBUPAY: {
    symbolSize: [29, 24]
  },
  POINT_FINNQ: {
    symbolSize: [40, 24]
  },
  POINT_FINSHOT: {
    symbolSize: [44, 24]
  },
  POINT_GLOBALMONEYEXPRESS: {
    symbolSize: [51, 24]
  },
  POINT_GOLFZONE: {
    symbolSize: [50, 24]
  },
  POINT_GOOGLEPAYMENTKOREA: {
    symbolSize: [24, 24]
  },
  POINT_HANAMONEY: {
    symbolSize: [24, 24]
  },
  POINT_HANPAYSYS: {
    symbolSize: [45, 24]
  },
  POINT_INTERPARK: {
    symbolSize: [60, 24]
  },
  POINT_KAKAOBANK: {
    symbolSize: [24, 24]
  },
  POINT_KAKAOPAY: {
    symbolSize: [39, 24]
  },
  POINT_KAKAO: {
    symbolSize: [40, 24]
  },
  POINT_KGMOBILLIANCE: {
    symbolSize: [32, 24]
  },
  POINT_KONAI: {
    symbolSize: [44, 24]
  },
  POINT_KOREAPREPAIDCARD: {
    symbolSize: [66, 24]
  },
  POINT_LOKAMOBILITY: {
    symbolSize: [24, 24]
  },
  POINT_LOTTESHOPPING: {
    symbolSize: [24, 24]
  },
  POINT_LPOINT: {
    symbolSize: [56, 24]
  },
  POINT_MYBI: {
    symbolSize: [32, 24]
  },
  POINT_NAVERPAY: {
    symbolSize: [48, 20]
  },
  POINT_OKCASHBACK: {
    symbolSize: [32, 24]
  },
  POINT_OKINVESTMENTPARTNERS: {
    symbolSize: [28, 24]
  },
  POINT_PAYCO: {
    symbolSize: [45, 24]
  },
  POINT_SETTLEBANK: {
    symbolSize: [24, 24]
  },
  POINT_SKCOMMUNICATIONS: {
    symbolSize: [38, 24]
  },
  POINT_SMHIPLUS: {
    symbolSize: [54, 24]
  },
  POINT_SMILEPAY: {
    symbolSize: [24, 24]
  },
  POINT_SSGPAY: {
    symbolSize: [49, 24]
  },
  POINT_TIMON: {
    symbolSize: [41, 24]
  },
  POINT_TMONEY: {
    symbolSize: [25, 24]
  },
  POINT_TOSSPAYMENTS: {
    symbolSize: [25, 24]
  },
  POINT_TOSSPOINTS: {
    symbolSize: [25, 24]
  },
  POINT_TRAVELWALLET: {
    symbolSize: [28, 24]
  },
  POINT_WELCOMEPAYMENTS: {
    symbolSize: [26, 24]
  },
  POINT_WEMAKEPRICE: {
    symbolSize: [36, 24]
  }
};
const EtcScheme = {
  ORG_KFTC: {
    profileName: 'BiDefaultSb',
    symbolSize: [42, 42]
  },
  ORG_KOSCOM: {
    profileName: 'BiDefaultSb',
    symbolSize: [42, 42]
  },
  ORG_SIGNGATE: {
    profileName: 'BiDefaultSb',
    symbolSize: [42, 42]
  }
};
const BiScheme = Object.entries({
  ...EtcScheme,
  ...BankScheme,
  ...InsuranceScheme,
  ...InvestScheme,
  ...CardScheme,
  ...SavingBankScheme,
  ...CapitalScheme,
  ...TelecomScheme,
  ...PointScheme
}).reduce((acc, _ref) => {
  let [key, value] = _ref;
  return {
    ...acc,
    [key]: {
      ...value,
      ...BI_BACKGROUND_INFO[key]
    }
  };
}, {});

export { BankScheme, BiScheme, CapitalScheme, CardScheme, EtcScheme, InsuranceScheme, InvestScheme, PointScheme, SavingBankScheme, TelecomScheme };
